module.exports = __webpack_public_path__ + "img/post1.ad6d65fb.png";